var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return Object.keys(_vm.variants).length
    ? _c("div", { staticClass: "dropdown" }, [
        _c(
          "button",
          {
            staticClass: "btn",
            class: _vm.getButtonClass,
            attrs: { "data-toggle": "dropdown" }
          },
          [
            _c("i", { class: _vm.getButtonIconClass }),
            _vm._v("\n        " + _vm._s(_vm.label) + "\n    ")
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dropdown-menu", class: _vm.getDropdownMenuClass },
          [
            _c(
              "ul",
              { staticClass: "kt-nav" },
              _vm._l(_vm.variants, function(variant, index) {
                return _c("li", { key: index, staticClass: "kt-nav__item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "kt-nav__link",
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          return _vm.onClick(index)
                        }
                      }
                    },
                    [
                      variant.icon
                        ? _c("i", {
                            staticClass: "kt-nav__link-icon",
                            class: variant.icon
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "kt-nav__link-text" }, [
                        _vm._v(_vm._s(variant.text))
                      ])
                    ]
                  )
                ])
              }),
              0
            )
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }